var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { placement: "bottom", size: "small" },
      on: { command: _vm.onChangeTableTools }
    },
    [
      _c(
        "el-button",
        { staticClass: "d2-mr btn-text can-hover", attrs: { type: "text" } },
        [
          _c("d2-icon", {
            staticStyle: { "font-size": "16px" },
            attrs: { name: "columns" }
          })
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "el-dropdown-item",
            { key: index, attrs: { command: item.command } },
            [
              _c("d2-icon", {
                staticClass: "d2-mr-5",
                attrs: {
                  name:
                    _vm.isTools == item.command ? "dot-circle-o" : "circle-o"
                }
              }),
              _vm._v(" " + _vm._s(item.name) + " ")
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }